import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './grid-operator-capacity.reducer';

export const GridOperatorCapacityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const gridOperatorCapacityEntity = useAppSelector(state => state.gridOperatorCapacity.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="gridOperatorCapacityDetailsHeading">
          <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.detail.title">GridOperatorCapacity</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{gridOperatorCapacityEntity.id}</dd>
          <dt>
            <span id="capacityCode">
              <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.capacityCode">Capacity Code</Translate>
            </span>
          </dt>
          <dd>{gridOperatorCapacityEntity.capacityCode}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.description">Description</Translate>
            </span>
          </dt>
          <dd>{gridOperatorCapacityEntity.description}</dd>
          <dt>
            <span id="meterType">
              <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.meterType">Meter Type</Translate>
            </span>
          </dt>
          <dd>{gridOperatorCapacityEntity.meterType}</dd>
          <dt>
            <span id="productType">
              <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.productType">Product Type</Translate>
            </span>
          </dt>
          <dd>{gridOperatorCapacityEntity.productType}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.type">Type</Translate>
            </span>
          </dt>
          <dd>{gridOperatorCapacityEntity.type}</dd>
          <dt>
            <span id="trancheLowerBound">
              <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.trancheLowerBound">
                Tranche Lower Bound
              </Translate>
            </span>
          </dt>
          <dd>{gridOperatorCapacityEntity.trancheLowerBound}</dd>
          <dt>
            <span id="trancheUpperBound">
              <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.trancheUpperBound">
                Tranche Upper Bound
              </Translate>
            </span>
          </dt>
          <dd>{gridOperatorCapacityEntity.trancheUpperBound}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.gridOperator">Grid Operator</Translate>
          </dt>
          <dd>{gridOperatorCapacityEntity.gridOperator ? gridOperatorCapacityEntity.gridOperator.ean : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.productOfferingPrice">
              Product Offering Price
            </Translate>
          </dt>
          <dd>
            {gridOperatorCapacityEntity.productOfferingPrices
              ? gridOperatorCapacityEntity.productOfferingPrices.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {gridOperatorCapacityEntity.productOfferingPrices &&
                    i === gridOperatorCapacityEntity.productOfferingPrices.length - 1
                      ? ''
                      : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/grid-operator-capacity" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/grid-operator-capacity/${gridOperatorCapacityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GridOperatorCapacityDetail;
